// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
// Constants
import { PARTNERS_WITH_EMBED_JS } from 'ChartApp/ts/apps/fund-chart-creator/constants';
// Interfaces
import { Partner } from 'ChartApp/ts/apps/fund-chart-creator/interfaces/fund-chart-creator.interface';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function ChartCreatorEmbedModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "input", 12);
    i0.ɵɵtwoWayListener("ngModelChange", function ChartCreatorEmbedModalComponent_div_8_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.embedCode, $event) || (ctx_r1.embedCode = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("click", function ChartCreatorEmbedModalComponent_div_8_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectEmbedCode($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.embedCode);
} }
function ChartCreatorEmbedModalComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 13);
    i0.ɵɵtext(2, " Loading... ");
    i0.ɵɵelementEnd()();
} }
export class ChartCreatorEmbedModalComponent {
    constructor(ajaxService) {
        this.ajaxService = ajaxService;
        this.modalOpen = false;
        this.embedCode = 'Loading...';
    }
    openModal() {
        this.modalOpen = true;
        // retrieve code via ajax only when requested
        this.getEmbedCode();
    }
    closeModal() {
        this.modalOpen = false;
    }
    getEmbedCode() {
        this.ajaxService.getJsonP(this.embedCodeUrl).subscribe((rsp) => {
            this.embedCode = rsp;
            // If the client requires embedded JavaScript, we generate the appropriate
            // command via string templating, then call `eval`. If the modal remains
            // open the link will appear in the text box, as it would without embedded
            // JS.
            if (PARTNERS_WITH_EMBED_JS.includes(this.partnerId)) {
                const customCommand = `CrossdomainSA.send('${this.embedCode}');`;
                /* eslint-disable no-eval */
                eval(customCommand);
                /* eslint-enable no-eval */
            }
        });
    }
    selectEmbedCode(event) {
        event.currentTarget.select();
    }
    copyEmbedCode() {
        const input = document.querySelector('#embedCode');
        if (input) {
            input.select();
            navigator.clipboard.writeText(input.value).then(() => { });
        }
    }
}
ChartCreatorEmbedModalComponent.ɵfac = function ChartCreatorEmbedModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartCreatorEmbedModalComponent)(i0.ɵɵdirectiveInject(i1.AjaxService)); };
ChartCreatorEmbedModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartCreatorEmbedModalComponent, selectors: [["ycn-chart-creator-embed-modal"]], inputs: { embedCodeUrl: "embedCodeUrl", partnerId: "partnerId" }, standalone: false, decls: 14, vars: 5, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], ["header", "Embed Chart View", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], [1, "form-label"], [1, "input-group"], ["class", "field-input-group input-group", 4, "ngIf"], [1, "input-group-btn"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], [1, "modal-footer"], [1, "field-input-group", "input-group"], ["id", "embedCode", 1, "form-control", 3, "ngModelChange", "click", "ngModel"], [1, "form-control"]], template: function ChartCreatorEmbedModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function ChartCreatorEmbedModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function ChartCreatorEmbedModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5);
        i0.ɵɵtext(6, " Copy the embed code below and paste into your intended destination. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, ChartCreatorEmbedModalComponent_div_8_Template, 2, 1, "div", 7)(9, ChartCreatorEmbedModalComponent_div_9_Template, 3, 0, "div", 7);
        i0.ɵɵelementStart(10, "span", 8)(11, "div", 9);
        i0.ɵɵlistener("click", function ChartCreatorEmbedModalComponent_Template_div_click_11_listener() { return ctx.copyEmbedCode(); });
        i0.ɵɵtext(12, " Copy ");
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelement(13, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.modalOpen);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.embedCode);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.embedCode);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", !ctx.embedCode);
    } }, dependencies: [i2.NgIf, i3.DisabledDirective, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i5.ModalBaseComponent, i6.SimpleModalHeaderComponent], encapsulation: 2 });
